import { render, staticRenderFns } from "./TotalMentionGraph.vue?vue&type=template&id=3f906d62&scoped=true&"
import script from "./TotalMentionGraph.vue?vue&type=script&lang=js&"
export * from "./TotalMentionGraph.vue?vue&type=script&lang=js&"
import style0 from "./TotalMentionGraph.vue?vue&type=style&index=0&id=3f906d62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f906d62",
  null
  
)

export default component.exports